module.exports = __webpack_public_path__ + "media/assets/images/flags/kh-c3f9ee7a081405a8c32273bc27fc1d12.svg";